import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import type { Maybe } from '@/lib/types';

import { visibilityControl } from '../../Card.styles';

export const Container = styled(Box)<{
  $backgroundColor: string;
  $visibleInDesktop?: Maybe<boolean>;
  $visibleInMobile?: Maybe<boolean>;
}>`
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  ${({ $visibleInDesktop, $visibleInMobile }) => css`
    ${visibilityControl($visibleInDesktop, $visibleInMobile)}
  `};
`;

export const Media = styled(Box)<{
  $backgroundAlignment: Maybe<string>;
}>`
  inset: 0;
  object-fit: cover;
  background-position: center;
  position: absolute;

  ${({ $backgroundAlignment }) => css`
    object-position: ${$backgroundAlignment || 'center'};
  `}
`;
